import { Navigate, Outlet, useLocation } from 'react-router-dom'

export interface ProtectedRouteProps {
  tokenKey?: string
  loginPath?: string
}

export const ProtectedRoute = ({
  tokenKey = 'admin_token',
  loginPath = '/login',
}: ProtectedRouteProps) => {
  const location = useLocation()
  const token = typeof window !== 'undefined' ? localStorage.getItem(tokenKey) : null

  if (!token) {
    const redirect = encodeURIComponent(location.pathname + location.search)
    return <Navigate to={`${loginPath}?redirect=${redirect}`} replace />
  }

  return <Outlet />
}

export default ProtectedRoute
